<nav class="fixed top-0 left-0 right-0 z-50 shadow-md bg-gray-hiquo" [class.navbar-fixed]="isFixed">
  <div class="container px-4 md:px-32 mx-auto">
    <div class="flex items-center justify-between h-20">
      <div class="flex-shrink-0 flex items-center gap-2 cursor-pointer" (click)="onLogoClick()">
        <img src="/images/logo.png" class="h-16 w-16 rounded-full object-cover" />
        <div>
          <span class="hidden md:block font-bold text-lg text-black">Hiquotroca</span>
          <span class="hidden md:flex items-center justify-center gap-3 mt-1 w-full">
            <a href="https://www.facebook.com/share/1HKeDaPSby/?mibextid=wwXIfr" target="_blank"
              rel="noopener noreferrer" aria-label="Facebook"
              (click)="$event.stopPropagation()"
              class="text-primary-hiquo hover:opacity-80 transition-opacity">
              <i class="fa-brands fa-facebook"></i>
            </a>

            <a href="https://www.instagram.com/hiquotroca?igsh=ZjZqZXQ0dGxpbGs2&utm_source=qr" target="_blank"
              rel="noopener noreferrer" aria-label="Instagram"
              (click)="$event.stopPropagation()"
              class="text-primary-hiquo hover:opacity-80 transition-opacity">
              <i class="fa-brands fa-instagram"></i>
            </a>
          </span>
        </div>
      </div>
      <div class="flex flex-1 max-w-2xl mx-4 md:mx-8">
        <p-iconfield class="w-full">
          <p-inputicon class="fa-solid fa-magnifying-glass"></p-inputicon>
          <input placeholder="Pesquisar artigos..." pInputText type="text" class="w-full" [ngModel]="searchQuery()"
            (ngModelChange)="searchQuery.set($event)" (keydown.enter)="onSearch()" />
        </p-iconfield>
      </div>

      <div class="flex items-center space-x-2">
        <div class="hidden md:flex items-center space-x-1">
          @if(user$ | async; as user)
          {
          <a routerLink="/about" class="flex flex-col items-center px-2 text-white" title="Sobre Nós">
            <p-avatar icon="fa-solid fa-user-group text-primary-hiquo" size="normal" shape="circle"
              style="background: white;"></p-avatar>
            <span class="text-xs text-gray-hiquo">Sobre Nós</span>
          </a>
          <a routerLink="/chat" class="flex flex-col items-center px-2 text-white" title="Mensagens">
            <p-avatar icon="fa-regular fa-envelope text-primary-hiquo" shape="circle"
              style="background: white;"></p-avatar>
            <span class="text-xs text-gray-hiquo">Mensagens</span>
          </a>
          <a routerLink="/wallet" class="flex flex-col items-center px-2 text-white" title="Carteira">
            <p-avatar icon="fa-solid fa-wallet text-primary-hiquo" shape="circle" style="background: white;"></p-avatar>
            <span class="text-xs text-gray-hiquo">Carteira</span>
          </a>
          <div class="relative" #userDropdown>
            <button (click)="toggleUserMenu()" class="cursor-pointer flex flex-col items-center px-2 text-white">
              <app-user-avatar [subscriptionPlan]="user.subscriptionType" [imageUrl]="user.profilePictureUrl" />
              <div class="flex items-center gap-0.5">
                <span class="text-xs text-gray-hiquo">Eu</span>
                <i class="fa-solid fa-chevron-down text-gray-hiquo text-[10px] transition-transform duration-200"
                  [class.rotate-180]="isUserMenuOpen"></i>
              </div>
            </button>
            @if (isUserMenuOpen) {
            <div
              class="absolute right-0 top-[calc(100%+8px)] w-60 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden z-[100]">
              <div class="px-4 py-3 border-b border-gray-100">
                <p class="text-sm font-semibold">{{ user.firstName }} {{ user.lastName }}</p>
              </div>
              <div class="py-1">
                <p class="px-3 pt-2 pb-1 text-[10px] font-bold uppercase tracking-wider">Conta</p>
                <a routerLink="/profile" (click)="isUserMenuOpen = false"
                  class="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors">
                  <i class="fa-solid fa-user text-primary-hiquo"></i> Informações do Utilizador
                </a>
                <a routerLink="/auth/forgot-password" (click)="isUserMenuOpen = false"
                  class="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors">
                  <i class="fa-solid fa-lock text-primary-hiquo"></i> Mudar Password
                </a>
                <!--  <a routerLink="/settings" (click)="isUserMenuOpen = false"
                  class="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors">
                  <i class="fa-solid fa-globe text-primary-hiquo"></i> Idioma
                </a> -->
                <button (click)="confirmDialog.open(); isUserMenuOpen = false"
                  class="cursor-pointer flex items-center gap-3 px-4 py-2 w-full text-sm hover:bg-gray-50 transition-colors">
                  <i class="fa-solid fa-user-minus text-red-600"></i> Eliminar Conta
                </button>
              </div>
              <div class="border-t border-gray-100 py-1">
                <p class="px-3 pt-2 pb-1 text-[10px] font-bold uppercase tracking-wider">Informação</p>
                <a routerLink="/my-products" [queryParams]="{actionType: 5}" (click)="isUserMenuOpen = false"
                  class="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors">
                  <i class="fa-solid fa-bullseye text-primary-hiquo"></i>Pedidos
                </a>
                <a routerLink="/my-favorites" (click)="isUserMenuOpen = false"
                  class="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors">
                  <i class="fa-regular fa-heart text-primary-hiquo"></i>Favoritos
                </a>
                <a routerLink="/help" (click)="isUserMenuOpen = false"
                  class="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors">
                  <i class="fa-solid fa-circle-question text-primary-hiquo"></i> Ajuda
                </a>
                <a routerLink="/terms" (click)="isUserMenuOpen = false"
                  class="flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors">
                  <i class="fa-solid fa-file-lines text-primary-hiquo"></i> Políticas
                </a>
              </div>
              <div class="border-t border-gray-100 py-1">
                <button (click)="onLogout()"
                  class="cursor-pointer flex items-center gap-3 px-4 py-2 w-full text-sm text-red-600 hover:bg-red-50 transition-colors">
                  <i class="fa-solid fa-sign-out-alt"></i> Terminar sessão
                </button>
              </div>
            </div>
            }
          </div>
          }
          @else {
          <a routerLink="/about" class="flex flex-col items-center px-2 text-white" title="Produtos">
            <p-avatar icon="fa-solid fa-user-group text-primary-hiquo" size="normal" shape="circle"
              style="background: white;"></p-avatar>
            <span class="text-xs text-gray-hiquo">Sobre Nós</span>
          </a>
          <a routerLink="/help" class="flex flex-col items-center px-2 text-white" title="Ajuda">
            <p-avatar icon="fa-regular fa-circle-question text-primary-hiquo" size="normal" shape="circle"
              style="background: white;"></p-avatar>
            <span class="text-xs text-gray-hiquo">Ajuda</span>
          </a>
          <a routerLink="/terms" class="flex flex-col items-center px-2 text-white" title="Políticas">
            <p-avatar icon="fa-regular fa-file-lines text-primary-hiquo" size="normal" shape="circle"
              style="background: white;"></p-avatar>
            <span class="text-xs text-gray-hiquo">Políticas</span>
          </a>
          <a routerLink="/wallet" class="flex flex-col items-center px-2 text-white" title="Carteira">
            <p-avatar icon="fa-solid fa-wallet text-primary-hiquo" shape="circle" style="background: white;"></p-avatar>
            <span class="text-xs text-gray-hiquo">Carteira</span>
          </a>
          <a routerLink="/auth/login" class="flex flex-col items-center px-2 text-white">
            <p-avatar icon="fa-solid fa-right-to-bracket text-primary-hiquo" size="normal" shape="circle"
              style="background: white;"></p-avatar>
            <span class="text-xs text-gray-hiquo">Login</span>
          </a>
          }
        </div>

        <button (click)="toggleMenu()"
          class="md:hidden p-2 rounded-lg text-primary-hiquo hover:bg-white/10 transition-colors"
          aria-label="Abrir menu">
          <i class="fa-solid fa-bars text-xl"></i>
        </button>
      </div>
    </div>
  </div>


</nav>

<p-drawer [(visible)]="isMenuOpen" position="left">
  @if(user$ | async; as user) {

  <div class="flex items-center gap-1 pb-4">
    <app-user-avatar [imageUrl]="user.profilePictureUrl"></app-user-avatar>
    <p class="font-semibold text-sm leading-tight">{{ user.firstName }} {{ user.lastName }}</p>
  </div>
  <p-divider align="right" type="dotted">
  </p-divider>
  <nav class="flex flex-col">
    <a routerLink="/about" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-user-group text-primary-hiquo w-5 text-center"></i> Sobre Nós
    </a>
    <a routerLink="/chat" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-regular fa-envelope text-primary-hiquo w-5 text-center"></i> Mensagens
    </a>
  </nav>

  <p-divider align="right" type="dotted">
    <b class="text-sm">Conta</b>
  </p-divider>

  <nav class="flex flex-col">
    <a routerLink="/profile" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-user text-primary-hiquo w-5 text-center"></i> Informações do Utilizador
    </a>
    <a routerLink="/auth/forgot-password" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-lock text-primary-hiquo w-5 text-center"></i> Mudar Password
    </a>
    <!--  <a routerLink="/settings" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-globe text-primary-hiquo w-5 text-center"></i> Idioma
    </a> -->
    <button (click)="confirmDialog.open(); isMenuOpen = false"
      class="cursor-pointer flex items-center gap-3 px-3 py-1.5 w-full rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-user-minus text-red-500 w-5 text-center"></i> Eliminar Conta
    </button>
  </nav>

  <p-divider align="right" type="dotted">
    <b class="text-sm">Informação</b>
  </p-divider>

  <nav class="flex flex-col">
    <a routerLink="/my-products" [queryParams]="{actionType: 5}" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-bullseye text-primary-hiquo w-5 text-center"></i> Pedidos
    </a>
    <a routerLink="/my-favorites" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-regular fa-heart text-primary-hiquo w-5 text-center"></i> Favoritos
    </a>
    <a routerLink="/wallet" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-wallet text-primary-hiquo w-5 text-center"></i> Carteira
    </a>
    <a routerLink="/help" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-circle-question text-primary-hiquo w-5 text-center"></i> Ajuda
    </a>
    <a routerLink="/terms" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-file-lines text-primary-hiquo w-5 text-center"></i> Políticas
    </a>
  </nav>

  <p-divider />

  <button (click)="onLogout(); isMenuOpen = false"
    class="cursor-pointer flex items-center gap-3 px-3 py-1.5 w-full rounded-lg text-red-600 hover:bg-red-50 transition-colors text-sm">
    <i class="fa-solid fa-sign-out-alt w-5 text-center"></i> Terminar sessão
  </button>

  } @else {
  <div class="flex flex-col gap-3">
    <p-button label="Iniciar Sessão" icon="fa-regular fa-user" routerLink="/auth/login" [raised]="true"
      styleClass="w-full justify-center" (onClick)="isMenuOpen = false" />
    <a routerLink="/about" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-user-group text-primary-hiquo w-5 text-center"></i> Sobre Nós
    </a>
    <a routerLink="/help" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-circle-question text-primary-hiquo w-5 text-center"></i> Ajuda
    </a>
    <a routerLink="/terms" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-file-lines text-primary-hiquo w-5 text-center"></i> Políticas
    </a>
    <a routerLink="/wallet" (click)="isMenuOpen = false"
      class="flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors text-sm">
      <i class="fa-solid fa-wallet text-primary-hiquo w-5 text-center"></i> Carteira
    </a>
  </div>
  }
</p-drawer>

<div class="h-20"></div>
<app-confirm-dialog (onAcceptDialog)="onConfirmDeleteUser()"></app-confirm-dialog>